import React, { useEffect } from "react";
import { TrophyOutlined } from "@ant-design/icons";
import { useDpatCommentFeedback } from "context/DpatCommentFeedbackContext";
import { useDpatIndicatorSlug } from "context/DpatIndicatorSlugContext";

const DPAT_PRIMARY = "#16325a";

export default function MaxScoreDisplay({ score }) {
  const slug = useDpatIndicatorSlug();
  const { registerIndicatorMaxScore } = useDpatCommentFeedback();

  useEffect(() => {
    if (slug != null && score != null && score !== "") {
      registerIndicatorMaxScore(slug, score);
    }
  }, [slug, score, registerIndicatorMaxScore]);

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "8px 12px",
        borderRadius: 8,
        border: `1.5px solid ${DPAT_PRIMARY}`,
        background: "linear-gradient(135deg, #f0f4f8 0%, #d6e4f0 100%)",
        boxShadow: "0 2px 8px rgba(22, 50, 90, 0.12)",
      }}
    >
      <TrophyOutlined style={{ fontSize: 14, color: DPAT_PRIMARY }} />
      <span
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.06em",
          color: "#595959",
          textTransform: "uppercase",
        }}
      >
        Maximum Score
      </span>
      <strong style={{ fontSize: 15, color: DPAT_PRIMARY, lineHeight: 1 }}>{score}</strong>
    </div>
  );
}
